{
  "onboarding": {
    "tally": {
      "line": "{{total}} — {{states}}",
      "separator": "، ",
      "outstanding": "غير مكتملة",
      "otherState": "أخرى: {{count}}",
      "missing": {
        "purchasing_units": {
          "none": "لا توجد وحدة شراء نشطة — لم تُضف أي وحدة بعد.",
          "some": "لا توجد وحدة شراء نشطة — {{states}}."
        }
      },
      "subject": {
        "regions_zero": "لا مناطق",
        "regions_one": "منطقة واحدة",
        "regions_two": "منطقتان",
        "regions_few": "{{count}} مناطق",
        "regions_many": "{{count}} منطقة",
        "regions_other": "{{count}} منطقة",
        "purchasing_units_zero": "لا وحدات شراء",
        "purchasing_units_one": "وحدة شراء واحدة",
        "purchasing_units_two": "وحدتا شراء",
        "purchasing_units_few": "{{count}} وحدات شراء",
        "purchasing_units_many": "{{count}} وحدة شراء",
        "purchasing_units_other": "{{count}} وحدة شراء",
        "categories_zero": "لا فئات",
        "categories_one": "فئة واحدة",
        "categories_two": "فئتان",
        "categories_few": "{{count}} فئات",
        "categories_many": "{{count}} فئة",
        "categories_other": "{{count}} فئة",
        "users_zero": "لا مستخدمين",
        "users_one": "مستخدم واحد",
        "users_two": "مستخدمان",
        "users_few": "{{count}} مستخدمين",
        "users_many": "{{count}} مستخدماً",
        "users_other": "{{count}} مستخدم",
        "approval_rules_zero": "لا قواعد اعتماد",
        "approval_rules_one": "قاعدة اعتماد واحدة",
        "approval_rules_two": "قاعدتا اعتماد",
        "approval_rules_few": "{{count}} قواعد اعتماد",
        "approval_rules_many": "{{count}} قاعدة اعتماد",
        "approval_rules_other": "{{count}} قاعدة اعتماد",
        "budgets_zero": "لا ميزانيات",
        "budgets_one": "ميزانية واحدة",
        "budgets_two": "ميزانيتان",
        "budgets_few": "{{count}} ميزانيات",
        "budgets_many": "{{count}} ميزانية",
        "budgets_other": "{{count}} ميزانية",
        "suppliers_zero": "لا موردين",
        "suppliers_one": "مورد واحد",
        "suppliers_two": "موردان",
        "suppliers_few": "{{count}} موردين",
        "suppliers_many": "{{count}} مورداً",
        "suppliers_other": "{{count}} مورد",
        "framework_agreements_zero": "لا اتفاقيات إطارية",
        "framework_agreements_one": "اتفاقية إطارية واحدة",
        "framework_agreements_two": "اتفاقيتان إطاريتان",
        "framework_agreements_few": "{{count}} اتفاقيات إطارية",
        "framework_agreements_many": "{{count}} اتفاقية إطارية",
        "framework_agreements_other": "{{count}} اتفاقية إطارية",
        "catalogue_items_zero": "لا أصناف في الكتالوج",
        "catalogue_items_one": "صنف واحد في الكتالوج",
        "catalogue_items_two": "صنفان في الكتالوج",
        "catalogue_items_few": "{{count}} أصناف في الكتالوج",
        "catalogue_items_many": "{{count}} صنفاً في الكتالوج",
        "catalogue_items_other": "{{count}} صنف في الكتالوج",
        "active_operational_records_zero": "لا وحدات شراء نشطة",
        "active_operational_records_one": "وحدة شراء نشطة واحدة",
        "active_operational_records_two": "وحدتا شراء نشطتان",
        "active_operational_records_few": "{{count}} وحدات شراء نشطة",
        "active_operational_records_many": "{{count}} وحدة شراء نشطة",
        "active_operational_records_other": "{{count}} وحدة شراء نشطة"
      },
      "state": {
        "regions": {
          "active": "النشطة: {{count}}",
          "inactive": "غير النشطة: {{count}}",
          "archived": "المؤرشفة: {{count}}"
        },
        "purchasing_units": {
          "active": "النشطة: {{count}}",
          "archived": "المؤرشفة: {{count}}",
          "draft": "المسودات: {{count}}",
          "inactive": "غير النشطة: {{count}}"
        },
        "categories": {
          "active": "النشطة: {{count}}",
          "inactive": "غير النشطة: {{count}}",
          "archived": "المؤرشفة: {{count}}"
        },
        "users": {
          "active": "النشطون: {{count}}",
          "invited": "المدعوون: {{count}}",
          "inactive": "غير النشطين: {{count}}",
          "suspended": "الموقوفون: {{count}}"
        },
        "approval_rules": {
          "in_force": "السارية: {{count}}",
          "scheduled": "المجدولة: {{count}}",
          "expired": "المنتهية: {{count}}",
          "inactive": "غير النشطة: {{count}}"
        },
        "budgets": {
          "active": "النشطة: {{count}}",
          "draft": "المسودات: {{count}}",
          "frozen": "المجمّدة: {{count}}",
          "closed": "المغلقة: {{count}}"
        },
        "suppliers": {
          "active_qualified": "النشطون المؤهَّلون: {{count}}",
          "active_not_qualified": "النشطون دون تأهيل سارٍ: {{count}}",
          "draft": "المسودات: {{count}}",
          "suspended": "الموقوفون: {{count}}",
          "archived": "المؤرشفون: {{count}}"
        },
        "framework_agreements": {
          "in_force": "السارية: {{count}}",
          "not_started": "التي لم تبدأ بعد: {{count}}",
          "expired": "المنتهية: {{count}}",
          "draft": "المسودات: {{count}}",
          "suspended": "المعلّقة: {{count}}",
          "terminated": "المنهاة: {{count}}"
        },
        "catalogue_items": {
          "active_with_source": "النشطة ولها مصدر توريد نشط: {{count}}",
          "active_without_source": "النشطة بلا مصدر توريد نشط: {{count}}",
          "inactive": "غير النشطة: {{count}}",
          "archived": "المؤرشفة: {{count}}"
        },
        "active_operational_records": {
          "covered": "المغطّاة: {{count}}",
          "at_risk": "المعرّضة للتعطّل: {{count}}",
          "blocked": "المتوقفة: {{count}}",
          "idle": "التي لا يرفع فيها أحد طلباً بعد: {{count}}"
        }
      }
    }
  }
}
